<script lang="ts" setup>
import type { Configuration } from '~/types/configurator'

const props = defineProps<{
  origin: {
    accessoriesOption: Configuration['accessoriesOptions'][number]
    accessory: Configuration['accessoriesOptions'][number]['values'][number]
  }
  accessories:
    | {
        accessoriesOption: Configuration['accessoriesOptions'][number]
        accessory: Configuration['accessoriesOptions'][number]['values'][number]
      }[]
    | {
        accessoriesOption: Configuration['accessoriesOptions'][number]
        oldAccessory: Configuration['accessoriesOptions'][number]['values'][number]
        newAccessory: Configuration['accessoriesOptions'][number]['values'][number]
      }[]
}>()

function isSwap(accessory: any): accessory is {
  accessoriesOption: Configuration['accessoriesOptions'][number]
  oldAccessory: Configuration['accessoriesOptions'][number]['values'][number]
  newAccessory: Configuration['accessoriesOptions'][number]['values'][number]
} {
  return 'oldAccessory' in accessory
}
</script>

<template>
  <div>
    <div class="last:border-b-4" v-for="accessory in props.accessories">
      <div
        class="grid grid-cols-[4rem_1fr_4rem] border-x-4 border-t-4 border-neutral-200 pr-3"
      >
        <div
          class="row-span-full flex h-full min-h-16 w-16 items-center justify-center"
        >
          <NuxtImg
            v-if="accessory.accessoriesOption.icon"
            :src="withHost(accessory.accessoriesOption.icon)"
            class="h-5 w-5"
            alt=""
          />
          <Icon v-else name="fa6-solid:gear" class="h-5 w-5" />
        </div>
        <div
          class="flex flex-col justify-center py-1 sm:flex-row sm:items-center sm:justify-between"
        >
          <p class="font-pragmatica-ext text-md font-bold sm:text-lg">
            {{ accessory.accessoriesOption.title }}
          </p>
          <p v-if="!isSwap(accessory)">
            {{ accessory.accessory.title }}
          </p>
          <div v-else class="flex flex-row items-center gap-1">
            <p>
              {{ accessory.oldAccessory.title }}
            </p>
            <Icon
              name="fa-solid:arrow-right"
              size="12"
              class="mt-0.5 min-w-4"
            />
            <p>
              {{ accessory.newAccessory.title }}
            </p>
          </div>
        </div>
        <div class="flex items-center justify-center">
          <div
            v-if="
              (!isSwap(accessory) && accessory.accessory.thumbnail) ||
              (isSwap(accessory) && accessory.newAccessory.thumbnail)
            "
            class="flex h-12 w-12 items-center justify-center overflow-hidden rounded-full bg-neutral-200"
          >
            <NuxtImg
              :src="
                withHost(
                  (!isSwap(accessory)
                    ? accessory.accessory.thumbnail
                    : accessory.newAccessory.thumbnail) + IMG_SIZE_100_100_FIT
                )
              "
              class="h-[90%] w-[90%] object-scale-down mix-blend-darken"
              alt=""
            />
          </div>
          <div
            v-else
            class="font-pragmatica-ext grid h-12 w-12 place-content-center rounded-full bg-black text-xs font-bold text-white"
          >
            <template
              v-if="
                (!isSwap(accessory) && accessory.accessory.accessoryNid) ||
                (isSwap(accessory) && accessory.newAccessory.accessoryNid)
              "
            >
              <span
                v-if="
                  (!isSwap(accessory)
                    ? accessory.accessory.title.length
                    : accessory.newAccessory.title.length) ||
                  0 <= MAX_WORD_LENGTH
                "
              >
                {{
                  !isSwap(accessory)
                    ? accessory.accessory.title
                    : accessory.newAccessory.title
                }}
              </span>
              <SvgSelected class="size-8 stroke-white stroke-[10]" v-else />
            </template>
            <SvgEmpty
              v-else-if="!accessory.accessoriesOption.multiselectable"
              class="mx-auto size-7 stroke-white stroke-[10]"
            />
            <IconPlus v-else class="size-12" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
